import { gql } from '@apollo/client';

export const SCORM_COURSE_QUERY = gql`
    query scormCourse($scormCourseID: UUID!) {
        scormCourse(scormCourseID: $scormCourseID) {
            node {
                id
                name
                status
                archiveUrl
                signedUrl
            }   
        }
    }
`;
